// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ProductReport":"em_a bhb_a bhb_x bhb_j bhb_u bhb_bc bhb_pp bhb_up"};